
import { APP_ID, CUSTOM_ELEMENTS_SCHEMA, DEFAULT_CURRENCY_CODE, Inject, NgModule, NO_ERRORS_SCHEMA, PLATFORM_ID } from '@angular/core';
import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';

import { EnvironmentConfig, ClooperCoreModule, FeatureToggle } from '@clooper/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppModalsModule } from './modals/modals.module';
import { ClooperModalsModule } from '@clooper/modals';
import { ClooperCommonModule } from '@clooper/common';

import { environment } from 'src/environments/environment';
import { featuresFlag } from 'src/configurations/feature-config';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';

import { HEADER_MENU_ITEMS } from '@clooper/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedModule } from './shared/shared.module';
import { TourModule } from './pages/corporate-account/tour/tour.module';

const headerMenuItems: any[] = [
  [
    {
      name: 'Find a property',
      url: '/listings'
    },
    // {
    //   name: 'Favorites',
    //   url: '/favorites'
    // }
    {
      name: 'Bookings',
      url: '/my-bookings'
    },
    {
      name: 'Favourites',
      url: '/favourites'
    },
    {
      name: 'Extra Services',
      url: '',
    },
    // {
    //   name: 'Listings',
    //   url: '/properties'
    // },
  ],
  [
    // {
    //   name: 'Messages',
    //   url: '/messages'
    // },
    {
      name: 'Payment History',
      url: '/payments'
    },
    // {
    //   name: 'Property Preference',
    //   url: '/tenant-profile'
    // },
    {
      name: 'Settings',
      url: '/settings'
    },
    {
      name: 'wallet',
      url: '/wallet'
    },
  ],
];

const businessMenuItems: any[] = [
  [
    {
      name: 'Find a property',
      url: '/listings'
    },
  ],
  [
    // {
    //   name: 'Messages',
    //   url: '/messages'
    // },
    {
      name: 'Payment History',
      url: '/corporate-account/settings/payment-methods'
    },
    {
      name: 'Property Preference',
      url: '/tenant-profile'
    },
    {
      name: 'Settings',
      url: '/corporate-account/settings'
    }
  ],
];

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'clooper-webapp' }),
    BrowserTransferStateModule,
    ClooperCoreModule.forRoot(),
    ClooperCommonModule,
    ClooperModalsModule,
    FontAwesomeModule,
    AppModalsModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    TourModule,
    ToastrModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    { provide: EnvironmentConfig, useValue: environment },
    { provide: FeatureToggle, useValue: featuresFlag },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'GBP' },
    { provide: HEADER_MENU_ITEMS, useFactory: () => headerMenuItems },
    // { provide: HEADER_MENU_ITEMS, useFactory: () => businessMenuItems },
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class AppModule {
  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject(APP_ID) private appId: string) {
    const platform = isPlatformBrowser(platformId) ?
      'in the browser' : 'on the server';
    // console.log(`Running ${platform} with appId=${appId}`);
  }
}
